/*
* @Author: yongwenhao
* @Date: 2020-04-07 10:35:22
* @describe: 服务内容数据
*/
let lang = sessionStorage.getItem('language') || 'zh';
const serviceData = {
    zh: {
        clinical: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: '临床运营',
                content: `临床运营业务是我们主要的业务单元及核心服务。`
            },
            listData: [
                {
                    title: '临床运营',
                    content: '临床研究系统流程标准化，项目管理运营、监查等团队较强的稳定性及中国主要临床基地的全面覆盖，都是我们引以为豪的成就。\n' +
                        '我们一直在践行进行临床试验的最佳方法，以此加速试验启动及组织实施的全过程，确保适当的试验监督，保证试验数据的高质量，并达成试验时限。',
                    pic: require('../assets/service/1.jpg')
                }
            ],
            helpData: [
                {
                    title: '可行性评估',
                    list: [
                        {
                            title: '临床试验可行性评估'
                        },
                        {
                            title: '中心/研究者识别'
                        },
                        {
                            title: '中心可行性评估&资质审核'
                        }
                    ]
                },
                {
                    title: '医学和临床策略&计划',
                    list: [
                        {
                            title: '临床试验计划&执行'
                        },
                        {
                            title: '风险识别&管理'
                        }
                    ]
                },
                {
                    title: '项目管理',
                    list: [
                        {
                            title: '项目监管和管理'
                        },
                        {
                            title: '项目团队协调和沟通'
                        },
                        {
                            title: '临床试验培训'
                        },
                        {
                            title: 'GCP培训'
                        },
                        {
                            title: ' 阶段进展报告'
                        },
                        {
                            title: '第三方管理'
                        },
                        {
                            title: '质量控制'
                        },
                        {
                            title: 'TMF和/或 e-TMF 创建&管理'
                        }
                    ]
                },
                {
                    title: '临床监查-从中心启动到中心关闭',
                    list: [
                        {
                            title: 'EC/IRB 提交'
                        },
                        {
                            title: 'HGRAC 提交'
                        },
                        {
                            title: '中心启动'
                        },
                        {
                            title: '研究者会议计划和执行'
                        },
                        {
                            title: 'IP 管理'
                        },
                        {
                            title: '供应管理'
                        },
                        {
                            title: 'SMF 创建&管理'
                        },
                        {
                            title: 'SAE 管理'
                        },
                        {
                            title: '质疑解答'
                        },
                        {
                            title: '关闭中心'
                        }
                    ]
                },
            ]
        },
        // 医学临床策略
        medical: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: '医学和临床策略',
                content: '医学和临床策略部 — 使您的战略与中国市场驱动因素保持一致'
            },
            listData: [
                {
                    title: '医学和临床策略',
                    content: `在CSC，我们了解您的产品是多么重要，而不能接收失败。 在开始临床研究前，尤其是第一次，您将面临一些亟待解决的问题，而我们可以帮助您快速找到这些问题的答案:
                         <span>• 当下我们应该如何降低未来潜在的法规风险</span>
                         <span>• 我们该如何说服投资者及股东支持我们临床实验开展的计划</span>
                         <span>• 应优先关注哪些适应症”, 还有很多很多其他问题</span>
                        为了让您的产品可以尽快帮助患者改善生活并被纳入中国医疗保健系统，您的临床开发过程以及后续的市场宣传必须具有战略性，针对性和统一性。 我们的医生，药理学家，流行病学家和统计学家团队可以帮助您量身定制临床开发路线图 –综合考虑成本及时间要素- 以提高您继续前行的信心，并最大限度地提高您的成功机会。`,
                    pic: require('../assets/service/2.jpg')
                }
            ],
            helpData: [
                {
                    title: '市场需求的早期评估和当前的治疗标准（SoC）',
                    list: []
                },
                {
                    title: '治疗领域策略',
                    list: []
                },
                {
                    title: '法规策略和计划',
                    list: []
                },
                {
                    title: '临床开发策略',
                    list: []
                },
            ]
        },
        // 医学事务
        affairs: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: '医学事务',
                content: '风险管理是每个临床试验必不可少的部分。'
            },
            listData: [
                {
                    title: '试验设计',
                    content: `CSC通过积极的风险管理措施，将降低风险计划作为试验设计的基础，贯彻于整个方案设计。 我们的医学团队拥有丰富的多学科临床研究设计经验，与专家以及KOL和顾问密切合作，通过合理的试验方案设计优化实际操作，进而提高试验成功率，并有效的控制项目成本。
        <p style="color: #394F9A">“如何优化我们的临床试验方案设计？”
        “可以使用我们的全球实验方案/ CRF吗？”
        “如何确保我们的试验设计与当地临床管理相结合？”</p>
        除了试验设计，我们的医学事务团队也可以使用相同的方法来帮您创建其他必要文档，如CRF，ICF，受试者日记卡等。`,
                    pic: require('../assets/service/3-1.jpg')

                },
                {
                    title: '临床研究报告（CSR）',
                    content: `我们的内部专家拥有丰富的经验，可以对临床试验结果进行清晰，简洁和专业的介绍 - 这是所有开发项目的重要组成部分。 在保证符合ICH（国际协调委员会）和其他法规要求的同时，我们也可以确保报告的准确性和一致性。`,
                    pic: require('../assets/service/3-2.jpg')
                },
                {
                    title: '医学监察',
                    content: `我们的医学监察团队是熟练的临床开发专业人员，并且战略性的分布在全国范围内，可及时密切的参与中心活动及协助研究者。`,
                    pic: require('../assets/service/3-3.jpg')
                }
            ],
            helpData: [
                {
                    title: '',
                    list: [
                        {
                            title: `临床试验培训`
                        },
                        {
                            title: '法规，医学和临床战略支持'
                        },
                        {
                            title: '医学监察'
                        },
                    ]
                },
                {
                    title: '临床试验方案的设计和审阅（I-IV期）',
                    list: [
                        {
                            title: '临床试验方案的设计和审阅（I-IV期）'
                        },
                        {
                            title: '知情同意书的撰写'
                        },
                        {
                            title: '研究者手册编辑'
                        },
                        {
                            title: '临床试验相关文件的翻译'
                        },
                        {
                            title: 'CRF设计'
                        },
                        {
                            title: '临床试验管理SOP'
                        },
                        {
                            title: '医学写作（临床试验总结报告、医学文章、研究报告等）'
                        },
                        {
                            title: '所有其他必要文件'
                        }
                    ]
                }
            ]
        },
        // 药物警戒&呼叫中心
        call: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: '药物警戒&呼叫中心',
                content: '专业的安全性管理，确保药物整个生命周期的安全性。'
            },
            listData: [
                {
                    title: '药物警戒&呼叫中心',
                    content: `为了确保药物的安全性，对药物风险进行评估并采取适当措施是非常重要的，这需要专业的安全性管理对药物开发到上市后阶段所发生的药物不良反应进行收集、检出、评估、监测和预防。
        通过建立以用户（患者）为中心的呼叫中心电子数据化技术整合系统，搭建企业与用户之间的沟通渠道，提供药品/医疗器械呼叫中心服务，从而协助企业降低研发成本、监测药品/医疗器械的安全性风险、促进公众健康，高质量、高效率、全方位地为客户提供多种服务进而提升用户对企业的包容度、满意度和忠诚度。`,
                    pic: require('../assets/service/5-1.jpg')

                }
            ],
            helpData: [
                {
                    title: '药物警戒',
                    list: [
                        {
                            title: '重点药品监测'
                        },
                        {
                            title: '药物安全信息管理'
                        },
                        {
                            title: '个例的安全报告'
                        },
                        {
                            title: '文献检索及处理'
                        },
                        {
                            title: '安全性信号的检出和管理'
                        },
                        {
                            title: '定期安全性更新报告（PSUR）的撰写、翻译及审核'
                        },
                        {
                            title: '风险控制计划（RCP）的撰写、翻译及审核'
                        },
                        {
                            title: '风险管理计划（RMP）的撰写、翻译及审核'
                        },
                        {
                            title: '医学监察'
                        }
                    ]
                },
                /*呼叫中心
        ·受试者访视提醒 　 　
        ·产品安全性信息收集　　　
        ·售前/售后服务　　　　　
        ·调查问卷　　　　　　　　
        ·语音质控　　　　　　　　
        ·知识库管理　　　　　　　
        ·用户信息管理　　　　　　
        ·项目管理
        ·数据统计分析及报告*/
                {
                    title: '呼叫中心',
                    list: [
                        {
                            title: '受试者访视提醒'
                        },
                        {
                            title: '产品安全性信息收集'
                        },
                        {
                            title: '售前/售后服务'
                        },
                        {
                            title: '调查问卷'
                        },
                        {
                            title: '语音质控'
                        },
                        {
                            title: '知识库管理'
                        },
                        {
                            title: '用户信息管理'
                        },
                        {
                            title: '项目管理'
                        },
                        {
                            title: '数据统计分析及报告'
                        }
                    ]
                }
            ]
        },
        // 投资/伙伴数据库
        partner: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: '投资/伙伴数据库',
                content: `无论您是在寻找资金设立合资企业还是许可，我们都可以为您提供帮助。`
            },
            listData: [
                {
                    title: '投资/伙伴数据库',
                    content: 'CSC已为100多家中国申办方提供服务，并与中国数千名行业专家和医疗保健公司建立了联络。 我们将评估您下面提供的信息，了解您的业务需求，以便我们为您提供相匹配的数据和资源。',
                    pic: require('../assets/service/5.jpg')
                }
            ]
        },
        // 质量保证稽查
        auditing: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: '质量保证&稽查',
                content: '通过高质量和高效率的增值服务，降低运营成本，提高临床试验质量。'
            },
            listData: [
                {
                    title: '质量保证&稽查',
                    content: `《药物临床试验管理规范》（GCP）是进行临床试验的通用伦理和科学质量标准。 随着越来越多的国际多中心临床试验在中国开展，对本土CRO来说遵守ICH标准非常重要。 幸运的是，对于我们CSC来说，这些原则自CSC成立以来就一直贯彻于我们工作的方方面面。 
        我们的QA团队由稽查顾问专家和专职QA人员所组成，平均15年以上国际和国内临床试验项目经验，10年以上临床试验稽查及其质量管理体系验证经验，若干专家是美国、欧盟的特聘稽查专家。稽查人员均熟悉国内外临床试验相关法律、法规及指导原则，了解相关疾病治疗指南，多位专家还担任过国内外药政当局和临床试验领域专业培训的教授或培训师。 `,
                    pic: require('../assets/service/6-1.jpg')
                }
            ],
            helpData: [
                {
                    title: '稽查类别',
                    list: [
                        {
                            title: '现场稽查'
                        }, {
                            title: '质量体系稽查'
                        }, {
                            title: '文件质量和完整性核查及研究文件(TMF)的认证'
                        }, {
                            title: '数据和统计管理的稽查'
                        }, {
                            title: '国内药品行政监督管理部门现场核查前的审核'
                        }, {
                            title: '电子临床系统验证及其管理合规性稽查'
                        }
                    ]
                },
                {
                    title: '稽查方式',
                    list: [
                        {
                            title: '远程稽查'
                        },
                        {
                            title: '现场稽查'
                        },
                    ]
                },
                {
                    title: '第三方稽查',
                    list: [
                        {
                            title: '合同研究组织'
                        }, {
                            title: '中心实验室'
                        }, {
                            title: '试验物质'
                        }, {
                            title: '物流供应商'
                        }, {
                            title: 'IWRS/IVRS'
                        }
                    ]
                },

            ]
        },
        // 药物临床试验中心
        drug: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: 'l期药物临床试验中心',
                content: '努力将我们独特的质量和服务标准带到早期临床试验中'
            },
            listData: [
                {
                    title: 'I期临床试验',
                    content: `近年来，中国在基础研究和工业研发方面加大了对药物创新的投入。 一些以前专注于仿制药的中国领先药厂已开始投资创新药物。 此外，还有一大批创新型生物技术公司 - 主要由美国和欧洲等海归专业人员推动 - 正致力于新疗法，以满足全球未满足的医疗需求。随着国内创新药物的增加和对国外早期开发的兴趣，CSC与山东省潍坊市第二人民医院合作，建立了一个由CSC主导运营和管理的I期药物临床试验中心。`,
                    pic: require('../assets/service/8-1.jpg')
                },
                {
                    title: '独立、安全、隐私',
                    content: 'Ⅰ期药物临床试验中心拥有床位60张，2张抢救床位，并配有资历雄厚，经验丰富的研究团队，满足国家市场监督管理总局（NMPA）要求。并建立了一整套管理制度、标准操作规程（SOP）和应急预案，规范Ⅰ期临床试验的全过程管理与实施。各功能区相对独立，安全性良好，保护受试者隐私和安全。',
                    pic: require('../assets/service/8-2.jpg')
                }
            ],
            helpData: [
                {
                    title: 'I期临床试验',
                    list: [
                        {
                            title: '单剂量爬坡试验',
                        },
                        {
                            title: '多剂量爬坡试验',
                        },
                        {
                            title: '医疗器械和药物治疗安全性试验',
                        }
                    ]
                },
                {
                    title: '创新药试验',
                    list: [
                        {
                            title: 'PD/PK试验',
                        },
                        {
                            title: 'PoC试验',
                        }
                    ]
                },
                {
                    title: '生物等效性试验',
                    list: [
                        {
                            title: '健康志愿者'
                        }, {
                            title: '试验患者'
                        }
                    ]
                }
            ]
        },
        // 特殊食品事业部
        food: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: '国际事务',
                content: '合作新模式：服务+投资'
            },
            listData: [
                {
                    title: '国际事务',
                    content: '除了传统的CRO服务，科林利康同时提供新的合作模式，即服务加投资。我们专业的国际化团队由科林利康核心管理团队担任指导小组，各服务模块负责人担任工作小组，和行业内顶尖专家团队共同组成，通过整合科林利康的全球资源，为客户提供从临床前到上市后的一站式解决方案。\n' +
                        '科林利康国际团队为客户提供专业的咨询及临床服务，我们的经验涵盖中美双报，全球多国申报，Ⅰ~Ⅳ期临床试验，药物警戒，医学监察，医学写作及生物统计服务。我们的专家有丰富的全球申报及临床资源，为您的全球一体化策略及产品生命周期提供专业指导。',
                    pic: require('../assets/service/10.jpg')
                },
            ],
            helpData: [
                {
                    title: '国内政府及大型基金资源',
                }, {
                    title: '国际战略合作的优质企业',
                }, {
                    title: '行业资讯及市场分析',
                }, {
                    title: '国际注册申报及全方位临床服务',
                }
            ]
        },
        // 数据管理&统计分析
        management: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: '数据管理&统计分析',
                content: '我们的团队由博士、硕士、学士学位、具有卓越的英语、日语等语言沟通能力的专业人员组成。'
            },
            listData: [
                {
                    title: '数据管理&统计分析',
                    content: `我们的数统团队熟悉国内外临床试验设计、执行、数据管理、统计分析，通晓国内外有关药品的管理法规和实施细则，同时他们也承担医生主导的方案培训，提供无缝、高性价比的解决方案，确保满足全球监管机构的标准，并保证您的业务拥有行业竞争优势。</br>
                    通过我们的全资子公司美达临床数据技术有限公司，我们为国内外客户提供全方位的数据管理、生物统计、药物安全警戒和呼叫中心服务，目前已为数十家国内外药企的创新药物和仿制药I-IV期及生物等效性临床试验提供了相关服务。</br>
                    美达遵循最高行业标准，符合ICH-GCP/FDA 21 CFR part 11/ CDISC/SDTM/国内外安全性信息管理法规要求的标准操作规程（SOP）以及严格的质量管理体系。`,
                    pic: require('../assets/service/11.jpg')
                },
            ],
            helpData: [
                {
                    title: '数据管理',
                    list: [
                        {
                            title: '数据管理咨询',
                        },
                        {
                            title: 'CRF设计和审核、注释CRF、CRF填写指南的撰写',
                        },
                        {
                            title: '数据库设计和创建',
                        },
                        {
                            title: '数据管理计划和报告的撰写',
                        },

                        {
                            title: '数据核查计划的撰写',
                        },
                        {
                            title: '数据录入和比较',
                        },
                        {
                            title: '数据核查和清理',
                        },
                        {
                            title: '质疑的生成/解决',
                        },
                        {
                            title: '严重不良事件的一致性核查',
                        },
                        {
                            title: '外部数据的一致性核查',
                        },
                        {
                            title: '医学编码',
                        },
                        {
                            title: '数据审核会议的支持',
                        },
                        {
                            title: '数据质量稽查',
                        }
                    ]
                },
                {
                    title: '统计分析',
                    list: [
                        {
                            title: '统计咨询',
                        },
                        {
                            title: '方案撰写和审核',
                        },
                        {
                            title: '随机化',
                        },
                        {
                            title: 'CRF审核',
                        },

                        {
                            title: '数据核查计划书的审核',
                        },
                        {
                            title: '统计分析计划及报告的撰写',
                        },
                        {
                            title: '制表/列表/图样表的作成',
                        },
                        {
                            title: '统计分析',
                        },
                        {
                            title: '统计监查',
                        },
                        {
                            title: '临床研究报告的建议和审核',
                        },
                        {
                            title: '数据监测委员会（DMC）支持',
                        },
                        {
                            title: '锁库前数据审核',
                        },
                        {
                            title: '揭盲',
                        }
                    ]
                },
                {
                    title: '统计编程',
                    list: [
                        {
                            title: '分析数据集(ADS)的作成',
                        },
                        {
                            title: 'CDISC SDTM数据创建和传输',
                        },
                        {
                            title: 'CDISC ADaM数据集创建',
                        },
                        {
                            title: '方案违背的编程',
                        },

                        {
                            title: '统计分析人群的编程',
                        },
                        {
                            title: '数据库锁库和传输',
                        },
                        {
                            title: '数据库的质控',
                        },
                        {
                            title: '统计编程',
                        },
                        {
                            title: '制表/列表/图的编程',
                        },
                        {
                            title: '制表/列表/图的编程及质控',
                        },
                        {
                            title: '临床数据的脱敏',
                        }
                    ]
                }
            ]
        },
        // 中心&患者管理
        patient: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: '中心&患者管理',
                content: '超过180个临床研究协调员（CRC）战略性地分布于全国50多个城市，随时随地提供即时的服务。'
            },
            listData: [
                {
                    title: 'CRiC —— 一个SMO公司',
                    content: `当您与研究者联系以帮助您进行临床试验时，您希望他们不遗余力，专注于患者招募和治疗。 但由于国内人口密集，农村地区缺乏专业护理，关键中心和主要研究者已经承担了试验之外的繁重工作量，而且往往会反映在他们的成绩上。时间久了，研究者参与试验的意愿可能会减弱。
                     这就是我们建立CRiC的原因 - 一个SMO公司。`,
                    pic: require('../assets/service/12.jpg')
                },
                {
                    title: 'CRiC临床研究',
                    content: `CRiC是CSC的全资子公司，为客户提供临床试验现场管理服务。 我们的CRC将被派往现场，以协助研究者承担和参与临床试验相关的行政负担，例如识别潜在患者，eCRF输入，患者管理，文件归档和跨部门沟通。我们的大部分CRC都是有护理、药学等相关经历，他们的相关医学、护理、药学等知识使他们可以更好的支持研究者，但他们并不参与任何医学判断相关的任务。
        在我们的支持下，研究者可以专注于重要的事情 - 他们的病人。`,
                    pic: require('../assets/service/9.jpg')
                },
            ],
            helpData: [
                {
                    title: '申办方及CRO',
                    list: [
                        {
                            title: '可行性调查',
                        },
                        {
                            title: '中心推荐',
                        }, {
                            title: 'EC递交支持',
                        }, {
                            title: '实验合同签订支持',
                        }, {
                            title: '协助患者随访',
                        }, {
                            title: '填写CRF,录入EDC',
                        }, {
                            title: '患者招募',
                        }, {
                            title: '跨部门沟通和写作',
                        }, {
                            title: '总结报告收集',
                        }, {
                            title: '关闭中心支持',
                        }, {
                            title: '项目管理',
                        }
                    ]
                },
                {
                    title: '研究者及医院临床试验管理',
                    list: [
                        {
                            title: '临床研究协调员支持',
                        },
                        {
                            title: '受试者招募规划',
                        },
                        {
                            title: '数据管理',
                        },
                        {
                            title: '独立的方案审计',
                        }
                    ]
                },
                {
                    title: '中心管理',
                    list: [
                        {
                            title: '中心SOP的执行及资格认定',
                        },
                        {
                            title: '稽查',
                        },
                        {
                            title: 'NMPA视察支持',
                        },
                        {

                        }
                    ]
                },
                {
                    title: '教育培训',
                    list: [
                        {
                            title: '研究者及其他人员的培训',
                        }
                    ]
                },
                {
                    title: '中心业务发展及推广',
                    list: [
                        {
                            title: '帮助研究中心招揽新的研究项目，挖掘潜在机遇',
                        },
                        {
                            title: '帮助研究中心进行市场拓展和商业能力发展',
                        }
                    ]
                }
            ]
        },
        // 药政事务部
        pharmaceutical: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: '药政事务',
                content: '与药政专家建立联系，及时与政府监管部门不断沟通，保持前瞻性的预测行业变化是非常重要的，以确保您的产品尽快上市。'
            },
            listData: [
                {
                    title: '药政事务',
                    content: `在CSC，我们了解您希望尽快将您的产品推向市场，而不走弯路。 但众所周知中国的监管环境比较复杂，并且法规有时动态更新很快。 
        “我们的产品应采取哪种注册途径？”
        “我们的产品是否能符合优先审核？”
        “我们需要从头开始注册，还是可以使用国外收集的数据？”
        自从CFDA于2018年9月改为国家药品监督管理局（NMPA）以来，我们看到了法规领域的一些重大改进。 一些对您最有利的改革包括：
        <p style="color: #394F9A">1.	临床试验申请（CTA）程序从约18个月减少到仅3个月（60个工作日）
        2.	NMPA“可以考虑国外数据”来支持申请
        3.	知识产权保护方面的重大改进</p>`,
                    pic: require('../assets/service/8.jpg')
                }
            ],
            helpData: [
                {
                    title: '项目法规和药政事务的咨询',
                    list: []
                },
                {
                    title: '项目注册策略&计划',
                    list: []
                },
                {
                    title: '注册申报文件的专业准备，提交和跟进，直到获得产品注册的上市许可证',
                    list: [
                        {
                            title: '原研国与中国申报资料要求的资料欠缺差异分析',
                        },
                        {
                            title: '与监管机构的沟通和交流',
                        },
                        {
                            title: '资料翻译',
                        }
                    ]
                }
            ]
        },
        // 中心影像诊断
        diagnosis: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: '中心影像',
                content: '提供一站式临床研发服务，降低运营成本，提高临床试验质量。'
            },
            listData: [
                {
                    title: '中心影像',
                    content: '目前由于国内很难找到满足中心影像需求的优质解决方案，申办方不得不向国外寻找解决方案，因此引起成本增加，甚至导致延期，并为管理过程带来不必要的复杂性，这些现在都可以避免。CSC已经开始在内部开发解决方案，为我们的客户提供无缝的端到端服务，并通过将中心影像引入到我们的业务模式中来实现这一目标。',
                    pic: require('../assets/service/9-1.jpg')
                },
            ],
            helpData: [
                {
                    title: '中心影像可为您提供以下服务',
                    list: [
                        {
                            title: '创新药研发服务联合电子医学源(e-Source)数据管理',
                        }
                    ],
                },
                {
                    title: '提供符合国际GCP和医学规范的医学影像评价全生命周期支持服务',
                    list: [
                        {
                            title: '包括影像数据上传，储存，下载，中心评价功能，及影像数据处理报告服务等',
                        }
                    ],
                },
                {
                    title: '药物医疗器械研发临床试验的中心影像判断和报告',
                    list: [],
                },
                {
                    title: '远程影像会诊涉及临床影像诊断各专业科室疾病领域',
                    list: [
                        {
                            title: 'X-Ray',
                        },
                        {
                            title: 'CT',
                        },
                        {
                            title: 'MRI等'
                        }
                    ],
                }
            ]
        },
    },
    en: {
        // 临床运营
        clinical: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: 'Clinical Operations',
                content: `Clinical Operations is our “bread and butter,” our core service solution.`
            },
            listData: [
                {
                    title: 'Clinical Operations',
                    content: 'We take pride in our standardized clinical management system and processes, low turnover rates, expert project management and audit teams, and our cost-effective coverage – with staff located in all in the key clinical trial locations around Mainland China.',
                    pic: require('../assets/service/1.jpg')
                }
            ],
            helpData: [
                {
                    title: 'Feasibility Assessments',
                    list: [
                        {
                            title: 'Study Feasibility Assessment'
                        },
                        {
                            title: 'Site/Investigator Identification'
                        },
                        {
                            title: 'Site Feasibility Assessment & Qualification'
                        }
                    ]
                },
                {
                    title: 'Clinical Strategy & Planning',
                    list: [
                        {
                            title: 'Study Planning & Execution'
                        },
                        {
                            title: 'Risk Identification & Management'
                        }
                    ]
                },
                {
                    title: 'Project Management',
                    list: [
                        {
                            title: 'Project Oversight and Management'
                        },
                        {
                            title: 'Project Team Coordination and Communication'
                        },
                        {
                            title: 'Study Training'
                        },
                        {
                            title: 'GCP Training'
                        },
                        {
                            title: 'Periodic Status Reports'
                        },
                        {
                            title: 'Third Party Management'
                        },
                        {
                            title: 'Quality Control'
                        },
                        {
                            title: 'TMF and/or e-TMF Development & Management'
                        }
                    ]
                },
                {
                    title: 'Clinical Monitoring – Site Initiation to Site Close-out',
                    list: [
                        {
                            title: 'EC/IRB Submissions'
                        },
                        {
                            title: 'HGRAC Submissions'
                        },
                        {
                            title: 'Site Initiation'
                        },
                        {
                            title: 'Investigator Meeting Planning and Execution'
                        },
                        {
                            title: 'IP Management'
                        },
                        {
                            title: 'Supply Management'
                        },
                        {
                            title: 'SMF Development & Management'
                        },
                        {
                            title: 'SAE Management'
                        },
                        {
                            title: 'Query Resolution'
                        },
                        {
                            title: 'Site Close-out'
                        }
                    ]
                },
            ]
        },
        // 医学临床策略
        medical: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: 'Medical & Clinical Strategy',
                content: 'Aligning your strategy to the right market drivers.'
            },
            listData: [
                {
                    title: 'Medical & Clinical Strategy',
                    content: `At CSC we understand how important your asset is to you and why failure is not an option. Before the start of a clinical trial, especially for the first time, you will be faced with some burning questions that we can help you find the answer to;
                 <span>• what can we do now to mitigate potential regulatory risks further down the path?</span>
                 <span>• How do we persuade our Investors and stakeholders to support our clinical trial development plans?</span>
                 <span>• Which indication(s) should we focus on first?,  and many, many more</span>
                 In order to let your products to enhance patients’ lives sooner and enter the Chinese healthcare system, your clinical development process and subsequent propagation into the market must be strategic, focused and unified. Our team of physicians, pharmacologists, epidemiologists and statisticians can help you create a tailored clinical development roadmap – combining the consideration of cost and timeline – to boost your confidence of selected path forward and maximize your chance of success.`,
                    pic: require('../assets/service/2.jpg')
                }
            ],
            helpData: [
                {
                    title: 'Early assessment of market needs and current Standards of Care (SoC)',
                    list: []
                },
                {
                    title: 'Therapeutic Area Strategy',
                    list: []
                },
                {
                    title: 'Regulatory Strategy & Plan',
                    list: []
                },
                {
                    title: 'Clinical Development Strategy',
                    list: []
                },
            ]
        },
        // 医学事务
        affairs: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: 'Medical Affairs',
                content: 'Risk Management is an integral part of any clinical trial.'
            },
            listData: [
                {
                    title: 'Study Design',
                    content: `At CSC we believe in taking a proactive approach to the management of risks by ensuring mitigation plans are interwoven to the foundation of our study designs. Our Medical Affairs team has extensive experience in multidisciplinary clinical study design, works closely with other departments’ in-house experts – as well as an extended network of local KOLs and Consultants – through rational methodology design to optimize operation, to improve study success rate and control study budget effectively. 
                    <p style="color: #394F9A">“How do we optimize our Protocol Design?”
“Can we use our Global Protocol/CRF in China?”
“How do we ensure our study design complies with local clinical practice?”</p>
Beyond study design, our Medical Affairs team can help create other Essential Documents such as CRF, ICF, Patient Diaries, etc., using these same methodologies.`,
                    pic: require('../assets/service/3-1.jpg')

                },
                {
                    title: 'Clinical Study Reports (CSR)',
                    content: `Our in-house experts have ample experience, they can present study findings in clear, concise, and professional manners, which is an important part of any programs development. We can ensure report accuracy and uniformity while maintaining full compliance with ICH (International Council for Harmonization) and other regulatory requirements. `,
                    pic: require('../assets/service/3-2.jpg')
                },
                {
                    title: 'Medical Monitoring',
                    content: `Our Medical Monitors are skilled clinical development professionals and are strategically located across the country to allow close and timely assistance to participating sites and investigators.`,
                    pic: require('../assets/service/3-3.jpg')
                }
            ],
            helpData: [
                {
                    title: '',
                    list: [
                        {
                            title: 'Regulatory, Medical & Clinical Strategy Support'
                        },
                        {
                            title: 'Study Training'
                        },
                        {
                            title: 'Medical Monoitring'
                        },
                    ]
                },
                {
                    title: 'Medical Writing',
                    list: [
                        {
                            title: 'Protocol Design and Review (Phase Ⅰ-Ⅳ)'
                        },
                        {
                            title: 'ICF Composing'
                        },
                        {
                            title: 'IB Design'
                        },
                        {
                            title: 'Medical Translation'
                        },
                        {
                            title: 'CRF Design'
                        },
                        {
                            title: 'Trial-Specific SOP Development'
                        },
                        {
                            title: 'Medical Writing (including CSR, medical articles, study report, etc.)'
                        },
                        {
                            title: 'All other Essential Documents'
                        }
                    ]
                }
            ]
        },
        // 药物警戒&呼叫中心
        call: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: 'Pharmacovigilance & Call Center',
                content: 'Professional safety management, ensure drug safety throughout the entire life cycle.'
            },
            listData: [
                {
                    title: 'Pharmacovigilance & Call Center',
                    content: `In order to ensure drug safety, it is important to assess risks of drugs properly and adopt corresponding measures, which requires professional safety management to collect, detect, assess, monitor and prevent adverse effects through development to post-marketing.
            By establishing an Electronic Data Integration (EDI) call center, it creates a communication channel between companies and clients that will help to decrease your R&D costs and assist you to monitor safety related risks of drugs/medical devices, promote public health, and provide your clients a variety of high-quality, efficient services, and enhance their clients experience to increase clients`,
                    pic: require('../assets/service/5-1.jpg')

                }
            ],
            helpData: [
                {
                    title: 'Pharmacovigilance ',
                    list: [
                        {
                            title: 'Intensive Drug Monitoring'
                        },
                        {
                            title: 'Drug Safety Information Management'
                        },
                        {
                            title: 'Individual Case Safety Report'
                        },
                        {
                            title: 'Literature Searching and Processing'
                        },
                        {
                            title: 'Signal Detection and Management'
                        },
                        {
                            title: 'Periodic Safety Update Reports'
                        },
                        {
                            title: 'Risk Control Plans Development'
                        },
                        {
                            title: 'Risk Management Plans Development'
                        },
                        {
                            title: 'Medical Review'
                        }
                    ]
                },
                // /*呼叫中心
                {
                    title: 'Call Center',
                    list: [
                        {
                            title: 'Subject Visit Reminder'
                        },
                        {
                            title: 'Product Safety Information Collection'
                        },
                        {
                            title: 'Pre-sales/After-sales Service'
                        },
                        {
                            title: 'Survey'
                        },
                        {
                            title: 'Voice Quality Control'
                        },
                        {
                            title: 'Knowledge Base Management'
                        },
                        {
                            title: 'User Information Management'
                        },
                        {
                            title: 'Project Management'
                        },
                        {
                            title: 'Data Analysis and Report'
                        }
                    ]
                }
            ]
        },
        // 投资/伙伴数据库
        partner: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: 'Investment / Partnership Database',
                content: `Whether you are looking for funding, to set up a JV or to out-license completely, we can help you.`
            },
            listData: [
                {
                    title: 'Investment / Partnership Database',
                    content: 'Clinical Services has served over 100 Chinese Sponsors and has an established network and connections with thousands of industry specialists and Healthcare companies across China. We will evaluate the information you provide below to understand your business needs, so that we can offer you the most relevant data and resources. Please fill in the form below in as much detail as possible so that we may identify the best matches for you.',
                    pic: require('../assets/service/5.jpg')
                }
            ]
        },
        // 质量保证稽查
        auditing: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: 'Quality Assurance & Audits',
                content: 'Reduce operating costs and improve clinical trial quality through high-quality and efficient value-added services'
            },
            listData: [
                {
                    title: 'Quality Assurance & Audits',
                    content: `Good Clinical Practice (GCP) is the universal ethical and scientific quality standard for conducting clinical trials. And as more and more Multi-Regional Clinical Trials (MRCT) are conducted in China, it has never been more important for local CROs to conform to ICH standards. Luckily for us at CSC, this is something we have incorporated in every aspect of our work since establishment. 
            Our QA team is composed of audit consultants and full-time QA personnel, has an average of more than 15 years of experience in global and domestic clinical trial projects, more than 10 years of experience in clinical trial audits and quality management system verification. Part of our QA team are experts nominated by FDA and EMA. Our auditors are familiar with global clinical trial laws, regulations and guidelines, and understand relevant disease treatment guidelines. Many of the experts have also served as professors or trainers of domestic and foreign regulatory authorities and professional training in the clinical trial field. `,
                    pic: require('../assets/service/6-1.jpg')
                }
            ],
            helpData: [
                {
                    title: 'Audit Catalog',
                    list: [
                        {
                            title: 'On-site Audits'
                        }, {
                            title: 'QMS Audits'
                        }, {
                            title: 'Document quality and integrity verification and Trial Master File (TMF) qualification.'
                        }, {
                            title: 'Database and Statistical Analysis Audits'
                        }, {
                            title: 'Pre-Inspection Preparation and Facilitation of Health Authority Inspections'
                        }, {
                            title: 'Electronic clinical system (e.g. EDC, CTMS, CDMS, IV(W)RS, etc.) verification and management compliance audit'
                        }
                    ]
                },
                {
                    title: 'Audit Methods',
                    list: [
                        {
                            title: 'Remote Audit'
                        },
                        {
                            title: 'On-Site Audit'
                        },
                    ]
                },
                {
                    title: 'Third Party Audit',
                    list: [
                        {
                            title: 'Contract Research Organization'
                        }, {
                            title: 'Central Laboratory'
                        }, {
                            title: 'Investigational Medicinal Product'
                        }, {
                            title: 'Logistics'
                        }, {
                            title: 'IWRS/IVRS'
                        }
                    ]
                }
            ]
        },
        // 药物临床试验中心
        drug: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: 'Phase I Unit',
                content: 'Bring our unique quality and service standards to early stage clinical trials'
            },
            listData: [
                {
                    title: 'Phase I Unit',
                    content: `China has stepped up investment in drug innovation in recent years, both in basic research and in industry research and development. Some of the leading Chinese pharmaceuticals that previously focused on generics have started building capabilities and making investments in innovative drugs. Furthermore, there is a large group of innovative biotech companies – driven mainly by US and EU-returnees – that are working on new therapies to address global unmet medical needs. With an increase in domestic innovation and more interest in early stage development from abroad, CSC has established a Phase I Unit, in collaboration with Weifang 2nd People’ s Hospital of Shandong Province, in a conscious effort to bring our unique quality and service standards to early stage clinical trials.`,
                    pic: require('../assets/service/8-1.jpg')
                },
                {
                    title: 'Independence, Safety, Privacy',
                    content: 'Our Phase I Unit is equipped with 60 beds, 2 emergency beds, a highly qualified and experienced research team and complies with GCP. We also developed and establish a set of management systems, standard operating procedures (SOPs) and emergency plans to standardize the entire process management of Phase I clinical trial and implementation. Each functional area is relatively independent, with good safety, protecting the privacy and safety of the subjects.',
                    pic: require('../assets/service/8-2.jpg')
                }
            ],
            helpData: [
                {
                    title: 'Phase I Clinical Trials',
                    list: [
                        {
                            title: 'Single Dose Escalation Studies',
                        },
                        {
                            title: 'Multiple Dose Escalation Studie',
                        },
                        {
                            title: 'Medical Device and Drug Treatment Safety Studies',
                        }
                    ]
                },
                {
                    title: 'Innovative Drug Trials',
                    list: [
                        {
                            title: 'PD/PK Studies',
                        },
                        {
                            title: 'PoC Trials',
                        }
                    ]
                },
                {
                    title: 'Bioequivalence Studies',
                    list: [
                        {
                            title: 'Healthy Volunteers',
                        },
                        {
                            title: 'Study Patients',
                        }
                    ]
                }
            ]
        },
        // 特殊食品事业部
        food: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: 'Global Business Affaires',
                content: 'New Business Model: Service + Investment'
            },
            listData: [
                {
                    title: 'Global Business Affaires',
                    content: `Apart from traditional CRO services, CSC has expanded its service offerings to a new business model in order to better serve the needs of all our clientele - Service plus Investment.
                    With our core management team acting as Steering Committee and a Working Group composed of the heads of each service department and top industry experts, CSC can combine its resources and knowledge of local and global industries to provide clients with a truly one-stop solution to their China-clinical needs – from preclinical to market.
                    Our Global Business Affairs team provides professional consultation and clinical services to clients from all over the world. Our experience covers China-US simultaneous submissions, multi-national simultaneous submissions, clinical operations, pharmacovigilance, medical monitoring, medical writing and biostatistics for clinical trials in all stages of development.
                    Our in-house experts have experience handling all types of global submissions and sufficient clinical resources in place to provide you with professional guidance on how to implement your global strategy through all stages of your products’ life cycle.`,
                    pic: require('../assets/service/10.jpg')
                },
            ],
            helpData: [
                {
                    title: 'Support you to identify and obtain funding',
                },
                {
                    title: 'Support your global clinical trial development/submission through our premium international strategic partners',
                },
                {
                    title: 'Provide up to date industry information and conduct market analyses',
                },
                {
                    title: 'Provide full-scope clinical services',
                }
            ]
        },
        // 数据管理&统计分析
        management: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: 'Data Management & Statistical Analysis',
                content: 'Our team consists of PhD and MS-level professionals, who have excellent English and/or Japanese language capabilities and communication skills.'
            },
            listData: [
                {
                    title: 'Data Management & Statistical Analysis',
                    content: `Our team are experienced function leaders with background of working with global pharmaceutical, medical device and CRO companies as well as regulatory agencies worldwide on various submissions, and undertaken extensive physician-led protocol training for each project to deliver high-quality results with QC and double programming implemented into all QA processes. </br>
                    Through our wholly owned subsidiary, Meta Clinical Technology Co. Ltd.(Meta), we provide a full-range of Data Management, Statistical Analysis, Pharmacovigilance, and Call Center services to our domestic and international clients. Currently, Meta has provided related services to numerous global/domestic pharmaceutical companies, range from bioequivalence, Phase I-IV, and post-market clinical trials of innovative and generic drugs.</br>
            At Meta we work to the highest industry standards, so that our deliverables meet all international health authority requirements – FDA, EMA and PMDA – including ICH-GCP/ FDA 21 CFR part 11 and the NMPA “Technical Guidelines for Data Management in Clinical Trials.”`,
                    pic: require('../assets/service/11.jpg')
                },
            ],
            helpData: [
                {
                    title: 'Data Management',
                    list: [
                        {
                            title: 'Data Management Consultation',
                        },
                        {
                            title: 'CRF Design/Review',
                        },
                        {
                            title: 'Database Design and Set-up',
                        },
                        {
                            title: 'Data Management Plan and Report Development',
                        },

                        {
                            title: 'Data Validation Plan Development',
                        },
                        {
                            title: 'Data Entry and Verification',
                        },
                        {
                            title: 'Data Validation and Cleaning',
                        },
                        {
                            title: 'Query Generation/Resolution',
                        },
                        {
                            title: 'Serious Adverse Event Reconciliation',
                        },
                        {
                            title: 'External Data Reconciliation',
                        },
                        {
                            title: 'Medical Coding',
                        },
                        {
                            title: 'Data Review Meeting Support',
                        },
                        {
                            title: 'Audit of Data Quality',
                        }
                    ]
                },
                {
                    title: 'Statistical Analysis',
                    list: [
                        {
                            title: 'Statistical Consulting',
                        },
                        {
                            title: 'Protocol Development',
                        },
                        {
                            title: 'Randomization Code Generation',
                        },
                        {
                            title: 'CRF Review',
                        },
                        {
                            title: 'Data Validation Plans Review',
                        },
                        {
                            title: 'Statistical Analysis Report Development',
                        },
                        {
                            title: 'Table, Listing, Figures (TLF) Mock-up Shell Development',
                        },
                        {
                            title: 'Statistical Analysis',
                        },
                        {
                            title: 'Statistical Monitoring',
                        },
                        {
                            title: 'CSR Review',
                        },
                        {
                            title: 'Data Monitoring Committee (DMC) Support',
                        },
                        {
                            title: 'Data Review Prior Database Lock',
                        },
                        {
                            title: 'Un-blinding',
                        }
                    ]
                },
                {
                    title: 'Statistical Programming',
                    list: [
                        {
                            title: 'Analysis Data Sets (ADS) Development',
                        },
                        {
                            title: 'CDISC SDTM Mapping and Transfer',
                        },
                        {
                            title: 'CDISC ADaM Dataset Development',
                        },
                        {
                            title: 'Programming of Protocol Deviations',
                        },

                        {
                            title: 'Programming of Analysis Populations',
                        },
                        {
                            title: 'Database Lock and Transfer',
                        },
                        {
                            title: 'Quality Control of Database',
                        },
                        {
                            title: 'Statistical Analysis Programming',
                        },
                        {
                            title: 'TLF Programming',
                        },
                        {
                            title: 'Quality Control of TLF programming',
                        },
                        {
                            title: 'Data Anonymization of Clinical Research',
                        }
                    ]
                }
            ]
        },
        // 中心&患者管理
        patient: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: 'Site & Patient Management',
                content: 'More than 180 Clinical Research Coordinators(CRC) who are strategically distributed in over 50 cities to provide immediate coverage wherever and whenever they are needed.'
            },
            listData: [
                {
                    title: 'CRiC——Site Management Organization (SMO) ',
                    content: `When you engage with an Investigator to help carry your asset through a clinical trial, you want their full attention on your study, focused on recruiting and treating patients. But in China, due mainly to dense population and lack of specialized care in rural areas, key sites and key investigators are already burdened with a heavy workload outside of your study, and oftentimes, it is reflected in their performance. Over time, Investigators’ willingness to be involved in a study can dwindle. This is why we established CRiC – an SMO. 。`,
                    pic: require('../assets/service/12.jpg')
                },
                {
                    title: 'CRiC Clinical Research',
                    content: `CRiC Clinical Research Co., Ltd. is a wholly owned subsidiary of CSC and provides our clients with Site Management services. Our CRC are dispatched to sites to assist Investigators with the administrative burden that is associated with taking part in clinical trials such as identifying potential patients, eCRF input, patient management, document filing and interdepartmental communication. Though the majority of our CRC are qualified nurses, they do not take part in any medical-related tasks, but their knowledge of how nursing and hospitals work puts them in a great position to support Investigators in everything they need.`,
                    pic: require('../assets/service/9.jpg')
                },
            ],
            helpData: [
                {
                    title: 'Sponsor & CRO',
                    list: [
                        {
                            title: 'Feasibility Study',
                        },
                        {
                            title: 'Site recommendation',
                        }, {
                            title: 'EC Submission Support',
                        }, {
                            title: 'Contract Finalization Support',
                        }, {
                            title: 'Assist Subjects in Follow-up',
                        }, {
                            title: 'CRF & EDC input',
                        }, {
                            title: 'Subject Recruitment',
                        }, {
                            title: 'Communication Bridge',
                        }, {
                            title: 'CSR Collection',
                        }, {
                            title: 'Site Close Support',
                        }, {
                            title: 'Project Management',
                        }
                    ]
                },
                {
                    title: 'Clinical Study Management',
                    list: [
                        {
                            title: 'Qualified and Experienced CRC Manning',
                        },
                        {
                            title: 'Recruitment Planning',
                        },
                        {
                            title: 'Data Management',
                        },
                        {
                            title: 'Conducting Independent Protocol Audit for Quality Assurance and Training Works',
                        }
                    ]
                },
                {
                    title: 'Site Management',
                    list: [
                        {
                            title: 'Qualification of Site SOP implementation',
                        },
                        {
                            title: 'Audit',
                        },
                        {
                            title: 'Assist NMPA Inspection',
                        },
                        {

                        },
                        {

                        }
                    ]
                },
                {
                    title: 'Education Training',
                    list: [
                        {
                            title: 'Trainings for Investigators & Others',
                        }
                    ]
                },
                {
                    title: 'Site Business Development and Promotion',
                    list: [
                        {
                            title: 'Help Site Developing New Study Projects and Potential Opportunities',
                        },
                        {
                            title: 'Help Site with Market Expansion and Business Capability Development',
                        }
                    ]
                }
            ]
        },
        // 药政事务部
        pharmaceutical: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: 'Regulatory Affairs',
                content: 'It’s important to have access to experts on the ground that are in constant communication with regulatory bodies and that stay ahead of industry-level changes, so that your submissions are always on the fastest route to market.'
            },
            listData: [
                {
                    title: 'Regulatory Affairs',
                    content: `At CSC we understand that you want to get your asset to market as soon as possible, with no room for setbacks. But the Chinese regulatory environment is notoriously difficult to navigate, and at times, can be quite volatile. 
"Which regulatory path should our product take?"
"Is our product eligible for Priority Review?"
"Do we need to conduct a registration from scratch, or can we use data collected abroad?"
Since the CFDA changed to the National Medical Product Association (NMPA) in September, 2018, we have seen some major improvements in the regulatory landscape. Some of the best changes that may affect your path include:
<p style="color: #394F9A">1.	Clinical Trial Application (CTA) process reduced from ~18 months to just 3 months (60 working days)
2.	NMPA is “willing to consider foreign data” to support submissions
3.	Significant improvements in IP Protection</p>`,
                    pic: require('../assets/service/8.jpg')
                }
            ],
            helpData: [
                {
                    title: 'Regulatory Consultation',
                    list: []
                },
                {
                    title: 'Regulatory Strategy & Plan',
                    list: []
                },
                {
                    title: 'Regulatory Package Preparation, Submission & Follow-up',
                    list: [
                        {
                            title: 'Gap Analysis',
                        },
                        {
                            title: 'Interact with Regulatory Bodies',
                        },
                        {
                            title: 'Document Translatio',
                        }
                    ]
                }
            ]
        },
        // 中心影像诊断
        diagnosis: {
            bannerContent: {
                src: require('../assets/back.jpg'),
                title: 'Central Imaging',
                content: 'We provide one-stop clinical research service, to help you lower your operation costs and improve the quality of clinical studies.'
            },
            listData: [
                {
                    title: 'Central Imaging',
                    content: 'In China, it is currently difficult to find a quality in-country solution to your central imaging needs. At the moment, Sponsors are being forced to look abroad for solutions which increases costs, study delays, and invites unnecessary complications to the management process that could otherwise be avoided. That is why CSC has begun developing a solution in-house. Our goal is to provide our clients with a seamless, end-to-end service scope, and by introducing Central Imaging to our business model, we are getting one step closer to attaining that goal.',
                    pic: require('../assets/service/9-1.jpg')
                },
            ],
            helpData: [
                {
                    title: 'Combined innovative drug research and development services and e-Source data managemen',
                    list: [],
                },
                {
                    title: 'Provide support services for medical imaging evaluation, which is in compliance with global GCP and medical standards, through full life cycle',
                    list: [
                        {
                            title: 'Including image data upload, storage, download, central evaluation function, and image data processing report services, etc.',
                        }
                    ],
                },
                {
                    title: 'Determine and report of central imaging for drugs/medical devices clinical trials.',
                    list: [],
                },
                {
                    title: 'Remote image consultation for imaging diagnosis of various disease',
                    list: [
                        {
                            title: 'X-Ray',
                        },
                        {
                            title: 'CT',
                        },
                        {
                            title: 'MRI etc.'
                        }
                    ]
                }
            ]
        }
    }
};

export default serviceData[lang]